const Joi = require("@hapi/joi");

module.exports = Joi.object({
	position: Joi.array()
		.items(
			Joi.number()
				.min(-180)
				.max(180)
		)
		.error(new Error("Coordinates are not correct"))
		.required(),
	name: Joi.string().required(),
	full_name: Joi.string(),
	pv_category: Joi.string().valid(
		"Rooftop PV",
		"Ground-mounted utility scale PV",
		"Floating PV"
	),
	pv_data: Joi.object({
		azimuth: Joi.number()
			.min(0)
			.max(180)
			.error(new Error("Azimuth must be a number between 0 and 180")),
		tilt: Joi.number()
			.min(0)
			.max(90)
			.error(new Error("Tilt must be a number between 0 and 90")),
		tracking: Joi.string()
			.valid("Fixed", "1 axis", "2 axis")
			.required()
			.messages({
				"any.required": "Tracking is a required field",
				"string.valid": "Tracking can only be 'Fixed', '1 axis' or '2 axis'"
			}),
		peak_power: Joi.number()
			.positive()
			.required()
			.error(new Error("Peak power must be a positive number")),
		losses: Joi.number()
			.min(0)
			.max(100)
			.error(new Error("Losses must be a number between 0 and 100"))
	}).required(),
	timezone: Joi.string(),
	created: Joi.date(),
	last_update: Joi.date(),
	forecasts: Joi.array()
});
